import { FC, useMemo } from "react";
import { capitalize, Stack, Typography } from "@mui/material";
import { useAppSelector } from "@/store/hooks";
import { budgetDetailsByIdDataSelector } from "@/store/budgets/selectors/details-drawer/budgetDetailsByIdDataSelector";
import { money } from "@/utils/numeral/money";
import { KeyValueSplitChip } from "@/components/common/chips/KeyValueSplitChip";
import { budgetAmountCellValueGetter } from "@/components/pages/budgets-and-alerts/components/grids/budgets/utils/helpers/value-getters/budgetAmountCellValueGetter";
import { BudgetsScopeCell } from "@/components/pages/budgets-and-alerts/components/grids/budgets/components/cells/BudgetsScopeCell";
import { organisationQuarterStartMonthSelector } from "@/store/common/selectors/org-current-settings/organisationQuarterStartMonthSelector";
import { budgetDetailsByIdLoadingSelector } from "@/store/budgets/selectors/details-drawer/budgetDetailsByIdLoadingSelector";
import { BudgetDetailsPeriod } from "@/components/pages/budgets-and-alerts/components/drawer/budget-details-drawer/components/body/common/BudgetDetailsPeriod";

export const BudgetDetailsSubHeader: FC = () => {
  const budgetDetails = useAppSelector(budgetDetailsByIdDataSelector);
  const quarterStartMonth = useAppSelector(
    organisationQuarterStartMonthSelector,
  );
  const loading = useAppSelector(budgetDetailsByIdLoadingSelector);

  const data = useMemo(() => {
    const budget = budgetAmountCellValueGetter(
      budgetDetails,
      quarterStartMonth,
    );

    return {
      "Budget Scope": <BudgetsScopeCell openInNew budget={budgetDetails} />,
      Budget: money(budget),
      Period: <BudgetDetailsPeriod />,
      "Budgeting Method": (
        <Typography variant="inherit">
          {capitalize(budgetDetails?.type ?? "")}
        </Typography>
      ),
    };
  }, [budgetDetails, quarterStartMonth]);

  return (
    <Stack direction="row" gap={1} flexWrap="wrap" py={1} px={2}>
      {Object.entries(data).map(([title, value]) => {
        return (
          <KeyValueSplitChip
            key={title}
            title={title}
            value={value}
            loading={loading}
            skeletonWidth={80}
          />
        );
      })}
    </Stack>
  );
};
